// @ts-nocheck
// GENERATED from PropelMapper/design@b27d324 — do not edit.
import * as React from "react";
// PMProgress.tsx — PropelMapper progress indicator.
//
// Linear bar or circular ring, determinate (value 0–100) or indeterminate
// (omit value). Token-driven; tone picks the fill color. role="progressbar"
// with aria-valuenow/min/max. For the branded local-first sync chip use the
// sibling PMSyncIndicator instead.
//
//   <PMProgress value={64} showValue />
//   <PMProgress variant="circular" />          // indeterminate spinner
//   <PMProgress variant="circular" value={40} tone="info" size={28} />

const PMPROG_CSS = `
.pmprog{font-family:var(--pm-font-sans);--pmprog-fill:var(--pm-primary)}
.pmprog--info{--pmprog-fill:var(--pm-info)}
.pmprog--success{--pmprog-fill:var(--pm-success)}
.pmprog--warning{--pmprog-fill:var(--pm-warning)}
.pmprog-linear{display:flex;align-items:center;gap:10px;width:100%}
.pmprog-track{position:relative;flex:1;height:8px;background:var(--pm-surface-variant);border-radius:999px;overflow:hidden}
.pmprog--sm .pmprog-track{height:6px}
.pmprog-fill{position:absolute;top:0;bottom:0;left:0;background:var(--pmprog-fill);border-radius:999px;transition:width .25s ease}
.pmprog-track.is-indet .pmprog-fill{width:40%;left:-40%;animation:pmprogIndet 1.25s cubic-bezier(.4,0,.2,1) infinite}
.pmprog-val{font:600 12.5px/1 var(--pm-font-sans);color:var(--pm-fg-2);min-width:34px;text-align:right;font-variant-numeric:tabular-nums}
@keyframes pmprogIndet{0%{left:-40%}50%{left:30%}100%{left:100%}}
.pmprog-circle{display:inline-block;vertical-align:middle}
.pmprog-circle.is-indet{animation:pmprogSpin .9s linear infinite;transform-origin:center}
.pmprog-circle .pmprog-arc{stroke:var(--pmprog-fill);transition:stroke-dashoffset .25s ease}
.pmprog-circle .pmprog-bg{stroke:var(--pm-surface-variant)}
@keyframes pmprogSpin{to{transform:rotate(360deg)}}
@media (prefers-reduced-motion: reduce){.pmprog-track.is-indet .pmprog-fill{animation-duration:2.4s}.pmprog-circle.is-indet{animation-duration:1.8s}}
`;

function pmprogEnsureCSS() {
  if (typeof document === "undefined" || document.getElementById("pmprog-css")) return;
  const s = document.createElement("style"); s.id = "pmprog-css"; s.textContent = PMPROG_CSS;
  document.head.appendChild(s);
}

export function PMProgress({
  variant = "linear",
  value,
  tone = "primary",
  size,
  showValue = false,
  label,
  className = "",
  style = {},
}: any) {
  pmprogEnsureCSS();
  const indeterminate = value == null || isNaN(value);
  const clamped = indeterminate ? 0 : Math.min(100, Math.max(0, value));
  const toneCls = tone && tone !== "primary" ? " pmprog--" + tone : "";
  const aria = {
    role: "progressbar",
    "aria-valuemin": 0,
    "aria-valuemax": 100,
    "aria-valuenow": indeterminate ? undefined : Math.round(clamped),
    "aria-label": label || (indeterminate ? "Loading" : undefined),
  } as any;

  if (variant === "circular") {
    const d = size || 36;
    const stroke = Math.max(3, Math.round(d / 11));
    const r = (d - stroke) / 2;
    const c = 2 * Math.PI * r;
    const arcLen = indeterminate ? c * 0.28 : c * (clamped / 100);
    return (
      <span className={"pmprog pmprog--circular" + toneCls + (className ? " " + className : "")} style={style} {...aria}>
        <svg className={"pmprog-circle" + (indeterminate ? " is-indet" : "")} width={d} height={d} viewBox={"0 0 " + d + " " + d}>
          <circle className="pmprog-bg" cx={d / 2} cy={d / 2} r={r} fill="none" strokeWidth={stroke} />
          <circle
            className="pmprog-arc"
            cx={d / 2} cy={d / 2} r={r} fill="none" strokeWidth={stroke} strokeLinecap="round"
            strokeDasharray={c}
            strokeDashoffset={c - arcLen}
            transform={"rotate(-90 " + d / 2 + " " + d / 2 + ")"}
          />
        </svg>
      </span>
    );
  }

  return (
    <div className={"pmprog pmprog-linear pmprog--linear" + toneCls + (size === "sm" ? " pmprog--sm" : "") + (className ? " " + className : "")} style={style}>
      <div className={"pmprog-track" + (indeterminate ? " is-indet" : "")} {...aria}>
        <div className="pmprog-fill" style={indeterminate ? undefined : { width: clamped + "%" }} />
      </div>
      {showValue && !indeterminate ? <span className="pmprog-val">{Math.round(clamped)}%</span> : null}
    </div>
  );
}
